import React from 'react';
import { PropsWithChildren } from 'react';
import { Row, Col } from 'reactstrap';

const QuestionField = ({
  question,
  value,
}: PropsWithChildren<{ question: string; value: string | string[] }>) => (
  <Row
    // noGutters
    className="d-flex justify-content-start border-bottom qtnnaire-report-item">
    <Col className="col-auto pt-2">
      <strong className="mb-0 mr-2">{question}:</strong>
    </Col>
    <Col className="col text-right pl-3 pt-2">
      <ul className="list-unstyled mb-0">
        {Array.isArray(value) ? (
          value.map((v, index) => <li key={index}>{v}</li>)
        ) : (
          <span>{value}</span>
        )}
      </ul>
    </Col>
  </Row>
);

export default QuestionField;
